import type { SelectField } from "@payloadcms/plugin-form-builder/types"
import type { Control, FieldErrorsImpl } from "react-hook-form"

import { Label } from "@/components/ui/label"
import {
	Select as SelectComponent,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select"
import React from "react"
import { Controller, useWatch } from "react-hook-form"

import { Error as FormError } from "../Error"
import { Width } from "../Width"
import { provinces } from "@/data/provinces"

export const Municipio: React.FC<
	SelectField & {
		control: Control
		errors: Partial<FieldErrorsImpl>
		form: { fields: Array<{ blockType: string; name: string }> }
	}
> = ({ name, control, errors, label, required, width, defaultValue, form }) => {
	// Find the provincia field name in the form
	const provinciaField = form?.fields?.find(
		(field) => field.blockType === "provincia",
	)
	const provinciaFieldName = provinciaField?.name || "provincia"

	// Watch the provincia field value
	const selectedProvinciaValue = useWatch({
		control,
		name: provinciaFieldName as string,
	})

	// Get municipalities based on selected province
	const selectedProvince = provinces.find(
		(p) => p.value === selectedProvinciaValue,
	)
	const municipalities = selectedProvince?.municipalities || []

	return (
		<Width width={width}>
			<Label htmlFor={name}>
				{label}
				{required && (
					<span className="required">
						* <span className="sr-only">(required)</span>
					</span>
				)}
			</Label>
			<Controller
				control={control}
				defaultValue={defaultValue}
				name={name}
				render={({ field: { onChange, value } }) => {
					const controlledValue = municipalities.find((m) => m.value === value)

					return (
						<SelectComponent
							onValueChange={(val) => onChange(val)}
							value={controlledValue?.value}
							disabled={!selectedProvinciaValue}
						>
							<SelectTrigger className="w-full" id={name}>
								<SelectValue
									placeholder={
										selectedProvinciaValue
											? label
											: "Seleccione una provincia primero"
									}
								/>
							</SelectTrigger>
							<SelectContent>
								{municipalities.map(({ label, value }) => {
									return (
										<SelectItem key={value} value={value}>
											{label}
										</SelectItem>
									)
								})}
							</SelectContent>
						</SelectComponent>
					)
				}}
				rules={{ required }}
			/>
			{errors[name] && <FormError name={name} />}
		</Width>
	)
}
